import { get, set, isArray, unset, isFunction } from 'lodash'

export default class Validator {
    constructor() {
        this.errors = {}
        this.model = null
        this.validators = null
    }

    validate(model, validators) {
        this.model = model
        this.validators = validators

        this.check(model, validators)
    }

    revalidate() {
        this.errors = {}
        this.check(this.model, this.validators)
    }

    check(model, validators) {
        Object.keys(validators).forEach(k => {
            let errors = new ErrorBag()
            const handler = get(validators, k, null)
            
            if (handler) {
                handler(model, errors)
                errors.getErrors().forEach(error => {
                    set(this.errors, error.field, error.errors)
                })
            }
            
        })
    }

    fieldErrors(field) {
        return get(this.errors, field, null)
    }

    pass() {
        return Object.keys(this.errors).length < 1
    }

    getErrors() {
        return this.errors
    }
}

class ErrorBag {
    constructor() {
        this.errors = []
    }

    add(field, errors) {
        this.errors.push({field,errors})
    }

    getErrors() {
        return this.errors
    }
}